import { REGEX_VALIDATION_EMAIL, REGEX_VALIDATION_PHONE, REGEX_VALIDATION_URL } from "../constants";
import NobuFormUI from "../objects/nobu-form";
import { selectElement } from "../utils/element-handlers.utils";
import $ from 'jquery';

type InquiriesFormFieldConfig = {
    fieldName: string,
    validator: InquiriesFormValidatorFunction
};

type InquiriesFormValidatorFunction = (value: string) => boolean;

interface InquiriesFormFieldInfo {
    name: string,
    value: string,
    isEmpty: boolean,
    isValid: boolean
}

const textValueValidator: InquiriesFormValidatorFunction = (value) => {
    return value.length > 2;
};

const emailValueValidator: InquiriesFormValidatorFunction = (value) => {
    return REGEX_VALIDATION_EMAIL.test(value.toLowerCase());
};

const phoneValueValidator: InquiriesFormValidatorFunction = (value) => {
    return REGEX_VALIDATION_PHONE.test(value.toLowerCase());
};

const urlValueValidator: InquiriesFormValidatorFunction = (value) => {
    return REGEX_VALIDATION_URL.test(value.toLowerCase());
};

const formFieldConfigList: InquiriesFormFieldConfig[] = [
    {
        fieldName: 'fullName',
        validator: textValueValidator
    },
    {
        fieldName: 'email',
        validator: emailValueValidator
    },
    {
        fieldName: 'phone',
        validator: phoneValueValidator
    },
    {
        fieldName: 'publication',
        validator: textValueValidator
    },
    {
        fieldName: 'website',
        validator: urlValueValidator
    },
    {
        fieldName: 'location',
        validator: textValueValidator
    },
    {
        fieldName: 'yourMessage',
        validator: textValueValidator
    }
];

export default function homeInquiriesPage() {
    const submitSuccessMessageElement = selectElement('#submit-success-message');

    selectElement<HTMLFormElement>('form.inquiries-form', formElement => {
        const nobuFormUI = new NobuFormUI(formElement);

        formElement.addEventListener('submit', event => {
            event.preventDefault();
            nobuFormUI.clearAllFieldErrors();

            const formData = new FormData(formElement);
            const emailReceivePressInquiries = ((entryValue) => entryValue === null ? null : String(entryValue))(formData.get('emailReceivePressInquiries'));

            if (!emailReceivePressInquiries) {
                return;
            }

            const formFieldInfoList: InquiriesFormFieldInfo[] = formFieldConfigList.reduce((acc, fieldConfig) => {
                const fieldValue = ((entryValue) => entryValue === null ? null : String(entryValue))(formData.get(fieldConfig.fieldName));

                if (fieldValue !== null) {
                    acc.push({
                        name: fieldConfig.fieldName,
                        value: fieldValue,
                        isEmpty: fieldValue.length === 0,
                        isValid: fieldConfig.validator(fieldValue)
                    });
                }

                return acc;
            }, [] as InquiriesFormFieldInfo[]);

            let hasErrors: boolean = false;
            
            const dataObject = formFieldInfoList.reduce((acc, formFieldInfo) => {
                if (formFieldInfo.isEmpty) {
                    hasErrors = true;
                    nobuFormUI.setFieldError(formFieldInfo.name, 'Please fill out this mandatory field');
                }
                else if (!formFieldInfo.isValid) {
                    hasErrors = true;
                    nobuFormUI.setFieldError(formFieldInfo.name, 'Please enter valid data');
                }
                else {
                    acc[formFieldInfo.name] = formFieldInfo.value;
                }

                return acc;
            }, {
                emailReceivePressInquiries
            } as {[fieldName: string]: string});

            if (hasErrors) {
                return;
            }

            $.ajax('/api/home/press-inquire', {
                method: 'POST',
                contentType : 'application/json',
                data: JSON.stringify(dataObject),
                success: function(data) {
                    if (data.success) {
                        if (submitSuccessMessageElement) {
                            formElement.style.display = 'none';
                            submitSuccessMessageElement.style.display = 'block';
                        }
                        else {
                            location.reload();
                        }
                    }
                    else {
                        nobuFormUI.setFormError(data.errorMessage || 'Unknown Error');
                    }
                }
            });
        });
    });
}
